import React, { Component } from "react"
import I18n from "../../utils/i18n.js"
import ReactDOM from "react-dom"
import _ from 'underscore'

import GiteFacetForm from '../../accommodations/forms/gite_facet_form'
import BNBFacetForm from '../../accommodations/forms/bnb_facet_form'
import SaleFacetForm from '../../accommodations/forms/sale_facet_form'
import AccommodationsMaps from '../../accommodations/apple_maps'
import AccommodationsList from '../../accommodations/list'
import AccommodationsPagination from '../../accommodations/pagination'
import createReactClass from 'create-react-class'
import * as MK from "../../utils/mapkit/utils"
import * as DL from '../../utils/datalayer'

export default createReactClass({
  getDefaultProps() {
    return {
      options: {},
      map: null,
      initial_params: {},
    };
  },

  getInitialState() {
    return {
      filters: null,
      clusters: [],
      paged_accommodations: this.props.paged_accommodations,
      bounds: null,
      page: parseInt(this.props.page) || 0,
      filtered_url: null,
      google_expiriments: {},
      paged_accommodations_updating: false,
      map_state: null,
      initialMapState: null,
      initialMapStateIsDefault: null,
      zoom: null,
      map_visible: null
    };
  },

  // Temporary fix
  fixSidenav() {
    if ($('.overview__list').width() === 480) {
      const navHeight = $('.sidenav__head').height() + $('.sidenav__body').height();
      return $('.st-pusher').height($(window).height() > navHeight ? $(window).height() : navHeight);
    }
  },

  // We initialize the router in "willMount" so we already have
  // filters when the component is going to render
  componentWillMount() {
    I18n.locale = this.props.locale;

    if (typeof Router === 'undefined' || Router === null) { return; }
    if (history.pushState) { window.location.hash = ''; }

    if ('ontouchstart' in window && 'onorientationchange' in window) {
      this.props.options.expanded = false;
    }

    this.fixSidenav();

    this.router = Router({
      '/(.*)': (filters) => {
        let booleans = history.pushState ?
          filters.split('/').slice(1)
        :
          filters.substring(0, filters.indexOf('?')).split('/');

        let params = this.getFiltersFromQuery(window.location.search.substring(1));

        // IE9 fix
        if (!window.location.search.substring(1)) {
          const { hash } = window.location;
          params = this.getFiltersFromQuery(hash.slice(hash.indexOf("?") + 1));
        }

        const query = this.baseEmptyFilters();

        _.each(this.listMapping(), function(key, type) {
          if (!params.hasOwnProperty(key) || (params[key] === "")) { return; }
          return booleans = booleans.concat(params[key].split('|'));
        });

        booleans = booleans.filter(b => b != null);

        booleans = booleans.map((boolean) => {
          const object = I18n.t('search.boolean_slugs');
          for (let k in object) {
            const v = object[k];
            if ((boolean === v) && _.contains(this.props.options.boolean_filters, k)) {
              boolean = k;
              break;
            }
          }

          return boolean;
        });

        _.each(booleans, (boolean) => {
          if (_.contains(this.props.options.boolean_filters, boolean)) { query.booleans.push(boolean); }
          if (_.contains(this.props.options.regions.map(a => a.slug), boolean)) { query.regions.push(boolean); }
          if (_.contains(this.props.options.areas.map(a => a.slug), boolean)) { query.areas.push(boolean); }
          if (_.contains(this.props.options.departments.map(a => a.slug), boolean)) { query.departments.push(boolean); }
          if (_.contains(this.props.options.language_filters, boolean)) { query.languages.push(boolean); }
          if (_.contains(this.props.options.object_types, boolean)) { query.object_types.push(boolean); }
          if (_.contains(this.props.options.object_sub_types, boolean)) { return query.subobject_types.push(boolean); }
        });

        _.each(this.props.options.scalar_filters, function(filter) {
          if (params[filter]) { return query[filter] = params[filter]; }
        });


        this.setState({filters: this.sanitizeFilters(query), page: parseInt(params.page || 1)});
        const map_state = this.mapStateFromParams(params);
        if ((map_state || this.state.initialMapState) !== null) {
          this.setState({map_state: map_state || this.state.initialMapState});
        }
        return this.setState({google_expiriments: {v: params.v, utm_expid: params.utm_expid}});
      }});

    this.router.configure({html5history: true});
    return this.router.init();
  },

  componentDidMount() {
    this.setState({map_visible: $('.overview__map').is(':visible')});
    $(window).resize(() => {
      if (this.resizeTimer) { clearTimeout(this.resizeTimer); }

      this.resizeTimer = setTimeout(() => {
        this.setState({map_visible: $('.overview__map').is(':visible')});
      }, 1000)
    })
  },

  mapStateFromParams(params) {
    let map_state = params.msa;
    if (!map_state) { return null; }

    return MK.mapStateFromUrlParam(map_state)
  },

  sanitizeFilters(filters) {
    const sanatized = this.baseEmptyFilters();

    const self = this;

    _.each(filters, function(value, filter) {
      if (self.isValidListType(filter)) {
        sanatized[filter] = _.flatten([value]);
        return;
      }

      if (!_.contains(self.props.options.scalar_filters, filter) || !filters[filter]) { return; }
      sanatized[filter] = value;
      if (isFinite(sanatized[filter])) { return sanatized[filter] = parseInt(sanatized[filter]); }
    });

    return sanatized;
  },

  baseEmptyFilters() {
    const filters = {};
    _.each(this.validListTypes(), key => filters[key] = []);
    return filters;
  },


  getFiltersFromQuery(searchQuery) {
    let match = '';
    const pl = /\+/g;
    const search = /([^&=]+)=?([^&]*)/g;
    const decode = s => decodeURIComponent(s.replace(pl, " "));

    const filters = {};
    while ((match = search.exec(searchQuery))) {
      filters[decode(match[1])] = decode(match[2]);
    }

    return filters;
  },

  updateFilteredPagedAccommodations(nextState) {

    const $top = $('.filter-results-top');
    const bounds = $top.get(0).getBoundingClientRect();
    const container = $(window).width() <= 479 ? document.querySelector('.st-content') : ReactDOM.findDOMNode(this.refs.scroller);
    const $container = $(container);

    if (bounds.top < 0) {

      $container.animate({
        'scrollTop': ($container.scrollTop() + bounds.top) - 40
      }, {
        duration: 650,
        easing: 'swing'
      });
    }

    const self = this;
    let url = this.props.options.url + this.getInternalUriForCurrentState();
    if (this.state.bounds && this.state.map_visible) { url += `&bounds=${this.state.bounds}`; }
    this.setState({paged_accommodations_updating: true});
    if (this.paged_request) { this.paged_request.abort(); }
    return this.paged_request = $.ajax({
      url,
      dataType: 'json',
      success(data) {
        return self.setState({paged_accommodations: data, highlightedAccommodation: null, paged_accommodations_updating: false});
      }
    });
  },

  createPromiseFor(nextState) {
    const deferred = $.Deferred();
    if (!nextState.filters || !nextState.filters.free_text || (nextState.filters.free_text === this.state.filters.free_text)) { return deferred.resolve(); }

    if (this.timer) { clearTimeout(this.timer); }

    this.timer = setTimeout(() => deferred.resolve()
    , 1000);

    return deferred.promise();
  },

  // nextProps/State really is prevProps/State
  componentDidUpdate(nextProps, nextState) {
    // This function includes some advanced logic for deciding wether or not to update the route, for code brevity consult the README
    const self = this;
    return this.createPromiseFor(nextState).then(function() {
      let map_pattern;
      const map_visible_equal = self.state.map_visible == nextState.map_visible;
      const filters_equal = _.isEqual(self.state.filters, nextState.filters);
      const bounds_equal  = _.isEqual(self.state.bounds, nextState.bounds);
      const page_equal    = parseInt(self.state.page) === parseInt(nextState.page);
      const map_state_eq  = MK.mapStateEqual(self.state.map_state, nextState.map_state);
      const path_pattern  = `${window.location.protocol}//${window.location.host}${window.location.pathname}`.replace(/[./]/g, "\\$&");
      if (window.location.search && new RegExp(`ms`).test(window.location.search)) { map_pattern   = window.location.search.replace(/[/?.]/g, "\\$&"); }
      const path_equal    = new RegExp(`${path_pattern}\\/?\\??${map_pattern || ''}$`).test(self.getRouteForCurrentState());

      if (!filters_equal) { self.trackFilters(nextState.filters); }

      if ((!filters_equal && !path_equal) || !page_equal || (!map_state_eq && nextState.map_state !== null && !path_equal)) {
        self.router.setRoute(self.getRouteForCurrentState());
      }
      if ((!filters_equal || !bounds_equal || !map_visible_equal) && !!self.state.map_state) {
        self.updateClusters();
      }

      // Only refresh page accommodations when:
      // - Filters not same as prev state OR
      // - Bounds not same as prev state AND prev state bounds not null or ms exists in initial params
      //   (they're null on first view, when we don't need to refresh them unless MS is given (which determine the bounds)) OR
      // - Current page not same in prev state
      if ((!map_visible_equal && nextState.map_visible !== null) || !filters_equal || (!bounds_equal && (nextState.bounds !== null || self.props.initial_params.msa)) || !page_equal) {
        self.updateFilteredPagedAccommodations(nextState);
      }

    });
  },

  trackFilters(prevState) {
    let filter = this.getUsedFilterOptions(this.state.filters, prevState);

    if (_.isEmpty(filter)) { filter = this.getUsedFilterScalarOptions(this.state.filters, prevState); }
    if (_.isEmpty(filter) || !filter[0]) { return; }

    const filter_group = this.getFilterGroup(filter[0]);
    if (!filter_group) { return; }

    return this.sendGAEvent(`Filter - ${this.props.options.type}`, filter_group, filter[0]);
  },

  getFilterGroup(filter) {
    const escaped_filter = filter.replace(/'/g,"\\'");
    const selector = `.sub-form #${escaped_filter}, .sub-form option[value='${escaped_filter}'], .sub-form select[name='${escaped_filter}']`;

    const $filter_input = $(selector).first();
    if (!$filter_input.length) { return; }

    const $sub_form = $filter_input.parents('.sub-form').first();
    return $sub_form.attr('class').replace(' sub-form', '').replace('form-row', '').trim();
  },

  getUsedFilterOptions(currentFilters, prevFilters) {
    // Find the new filter that has been selected
    // Ignore numbers, these are handled by getUsedFilterScalarOptions
    return _.difference(
        _.flatten(_.map(currentFilters, function(v, k) { if (!_.isNumber(v) && (k !== 'free_text')) { return v; }  })),
        _.flatten(_.map(prevFilters, function(v, k) { if (!_.isNumber(v) && (k !== 'free_text')) { return v; }  }))
    );
  },

  getUsedFilterScalarOptions(currentFilters, prevFilters) {
    const key = [];
    _.each(currentFilters, function(v, k) {
      if (_.isNumber(v) && (v !== prevFilters[k])) { return key.push(k); }
    });

    return key;
  },

  sendGAEvent(event, group, filter) {
    DL.push({
      event: 'gites',
      category: event,
      action: group,
      label: filter,
    });
  },

  updateClusters() {
    if (!this.state.map_visible || !this.state.bounds) {
      this.setState({clusters: [], highlightedAccommodation: null})
      return
    }
    const self = this;
    let url = this.props.options.maps_url + this.getInternalUriForCurrentState();
    if (this.state.bounds) { url += `&bounds=${this.state.bounds}`; }
    url += `&zoom=${this.state.zoom}`;

    if (this.filtered_request) { this.filtered_request.abort(); }
    return this.filtered_request = $.ajax({
      url,
      dataType: 'json',
      success(data) {
        return self.setState({clusters: data, highlightedAccommodation: null});
      }
    });
  },

  handleFormChange(filters) {
    return this.setState({filters: this.sanitizeFilters(filters), page: 1});
  },

  listMapping() {
    return {
      booleans: 'b',
      languages: 'l',
      regions: 'r',
      departments: 'd',
      areas: 'a',
      object_types: 't',
      subobject_types: 'st'
    };
  },

  validListTypes() {
    return _.keys(this.listMapping());
  },

  isValidListType(type) {
    return _.contains(this.validListTypes(), type) === true;
  },

  getUriFor(filters, page, map_state, alwaysAddMapState) {
    if (page == null) { page = 1; }

    let uri = {};
    const self = this;
    _.each(filters, function(value, key) {
      if (!value) { return; }
      if (!self.isValidListType(key)) { return uri[key] = value; }
    });

    _.each(this.listMapping(), function(qv, key) {
      if (!!filters && !!filters[key] && (filters[key] !== null) && (filters[key] !== undefined) && (filters[key].length !== 0)) { return uri[qv] = filters[key].join('|'); }
    });

    if (page > 1) { uri.page = page; }

    if (map_state && (alwaysAddMapState || !this.state.initialMapStateIsDefault || (!MK.mapStateEqual(map_state, this.state.initialMapState) && this.state.initialMapState))) {
      uri.msa = MK.mapStateToUrlParam(map_state)
    }

    if (this.state.google_expiriments && (_.reject(_.values(this.state.google_expiriments), v => typeof(v) === 'undefined').length > 0)) { uri = _.extend(uri, this.state.google_expiriments); }

    return `?${$.param(uri)}`;
  },

  getRouteForCurrentState() {
    if (!this.state.filters) { return this.props.options.base_url; }
    const filters = _.clone(this.state.filters);
    filters.booleans = filters.booleans.map(boolean => I18n.t(`search.boolean_slugs.${boolean}`, {defaultValue: boolean}));

    const uri = this.props.options.base_url;

    let booleans = [];
    _.each(['booleans', 'regions', 'departments', 'areas', 'object_types', 'subobject_types'], function(type) {
      booleans = booleans.concat(filters[type]);
      return filters[type] = [];
  });

    booleans = _.uniq(booleans);

    if (history.pushState) {
      return uri + "/" + booleans.join('/') + this.getUriFor(filters, this.state.page, this.state.map_state);
    } else {
      return booleans.join('/') + this.getUriFor(filters, this.state.page, this.state.map_state);
    }
  },

  getInternalUriForCurrentState() {
    return this.getUriFor(this.state.filters, this.state.page, this.state.map_state || this.state.initialMapState, true);
  },

  handleVisibleAccommodationsChange(bounds) {
    if (typeof(bounds) === 'object') { bounds = bounds.toUrlValue(); }
    if ((bounds !== this.state.bounds) && (this.state.bounds != null)) { this.setState({page: 1}); }
    return this.setState({bounds});
  },

  handleHighlightedAccommodation(accommodation) {
    const self = this;
    return setTimeout(() => self.setState({highlightedAccommodation: accommodation})
    , 500);
  },

  handlePagination(page) {
    return this.setState({page});
  },

  showAllOnMap() {
    return this.refs.overview__map.showAllOnMap();
  },

  setInitialMapState(region) {
    if (this.state.initialMapState) {
      return;
    }

    this.setState({ initialMapState: region })
  },

  accommodationPropsFor(state) {
    if (!state.filters) { return; }

    const props = [];
    props.push(state.filters.end_date);
    props.push(state.filters.start_date);
    props.push(state.filters.max_persons);

    return props;
  },

  window() {
    return typeof window !== 'undefined' && window !== null
  },

  renderMaps() {
    return <div className="overview__map">
      {this.window() && this.state.map_visible ? <AccommodationsMaps
      setInitialMapState={(state) => this.setInitialMapState(state)}
      map_state={this.state.map_state || this.state.initialMapState}
      ref="overview__map"
      setZoom={(zoom) => this.setState({zoom})}
      default_bounds={this.props.map_options ? this.props.map_options.default_bounds : null}
      highlightedAccommodation={this.state.highlightedAccommodation}
      setBounds={this.handleVisibleAccommodationsChange}
      clusters={this.state.clusters.results}
      getMapsSnippetLink={(accommodation) => this.props.options.base_advert_url.replace('1', accommodation.id)}
      setMapState={(region) => this.setState({ map_state: region })}
      setInitialMapStateIsDefault={(isDefault) => this.setState({ initialMapStateIsDefault: isDefault })}
      className='overview__mapmap'
    /> : ''}</div>
  },

  render() {
    let map, pagination_top, show_all;
    const total_without_bounds = this.state.paged_accommodations.facets ? this.state.paged_accommodations.facets.bounds : 0;

    const page = this.state.page || 1;
    if (this.refs.overview__map) { ({ map } = this.refs.overview__map.state); }

    const form = (() => { switch (this.props.options.type) {
      case 'gites':
        return <GiteFacetForm className="overview__filters" options={this.props.options} map={map} filters={this.state.filters} results={total_without_bounds} facets={this.state.paged_accommodations.facets} onFormChange={this.handleFormChange} onHandleFormChange={this.handleFormChange} />;
      case 'bed_and_breakfasts':
        return <BNBFacetForm className="overview__filters" options={this.props.options} map={map} filters={this.state.filters} results={total_without_bounds} facets={this.state.paged_accommodations.facets} onFormChange={this.handleFormChange} onHandleFormChange={this.handleFormChange} />;
      case 'sales':
        return <SaleFacetForm className="overview__filters" options={this.props.options} map={map} filters={this.state.filters} results={total_without_bounds} facets={this.state.paged_accommodations.facets} onFormChange={this.handleFormChange} onHandleFormChange={this.handleFormChange} />;
    } })();

    const paged_total = this.state.paged_accommodations.total;

    const results_header = I18n.t(`search.results_header_${this.props.options.type}`);

    const humanized_results = paged_total > total_without_bounds ?
      ''
    : paged_total > 1000 ?
      I18n.t(`search.results_title_limited_${this.props.options.type}`)
    : (paged_total === 0) && (total_without_bounds > 0) ?
      total_without_bounds > 1000 ?
        I18n.t(`search.results_title_none_visible_limited_${this.props.options.type}`)
      :
        I18n.t(`search.results_title_none_visible_${this.props.options.type}`, {count: total_without_bounds})
    :
      I18n.t(`search.results_title_${this.props.options.type}`, {count: paged_total});

    const results_klasses = ['results-counter'];
    if ((paged_total === 0) && (total_without_bounds > 0)) {
      show_all = <div className="btn-cta" onClick={this.showAllOnMap}>{I18n.t('search.show_complete_selection')}</div>;
      results_klasses.push('show_all');
    }

    if (page > 1) {
      pagination_top = <AccommodationsPagination url={this.getRouteForCurrentState()} page={page} onPaginate={this.handlePagination} total={paged_total} position="top"/>;
    }

    const update_overlay = '';

    return <div className="overview">
      {this.renderMaps()}
      <div className="overview__list" ref="scroller">
        {form}
        <div className="overview__results">
          {update_overlay}
          <h1 className="results-header">{results_header}</h1>
          <div className={results_klasses.join(' ')}>
            {humanized_results}
            {show_all}
          </div>
          {pagination_top}
          <AccommodationsList
            total={total_without_bounds}
            options={this.props.options}
            onPaginate={this.handlePagination}
            onAccommodationChange={this.handleHighlightedAccommodation}
            accommodations={this.state.paged_accommodations.adverts}
            filters={this.state.filters}
            priceDeps={this.accommodationPropsFor(this.state)}
            isUpdating={this.state.paged_accommodations_updating}
            ref="list"
          />

          <AccommodationsPagination
            url={this.getRouteForCurrentState()}
            page={page}
            onPaginate={this.handlePagination}
            total={paged_total}
            position="bottom"
          />
        </div>
      </div>
    </div>;
  }
});
